import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { AUTH_API } from "./apiRoutes";

const mutateForgotPassword = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${AUTH_API}/request-password-rest`, data);
};

const useForgotPasswordMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateForgotPassword,
    ...queryParams,
  });

export default useForgotPasswordMutation;
